import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.user.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-component-user-home',
template: templateSource || '',
    styles: [``],
})
export class ComponentUserHomeComponent implements OnInit {
    public machineCount: number | null = null;
    public totalQuantity: number | null = null;
    public totalWeight: number | null = null;
    public totalPlate: number | null = null;

    public gradeLog: any[] = [];
    public productChart: any[] = [];

    public eggprice: any = null;
    public statisticChart: any = null;
    public efficiencyChart: any = null;
    public farmId: string = '';
    public communicationData: any = { machine: false, env: false };

    constructor(@Inject( Service)         public service: Service,@Inject( Title    )         private title: Title    ) { }

    async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, "/auth/login");
        if (!allowed) return;
        this.title.setTitle('에그텍스마트플랫폼 사용자 페이지');
        await this.load();
    }

    private async load() {
        const [statisticRes, eggPriceRes, statusRes] = await Promise.all([
            wiz.call('statistic'),
            wiz.call('eggprice'),
            wiz.call('status')
        ]);

        this.applyStatistic(statisticRes);
        this.applyEggPrice(eggPriceRes);

        if (!this.farmId && statusRes?.code === 200 && statusRes.data) {
            this.farmId = statusRes.data.farm_id || '';
        }
        this.applyCharts(statusRes);
        this.applyCommunication(statisticRes, statusRes);

        await this.service.render();
    }

    private applyCommunication(statisticRes: any, statusRes: any) {
        const hasMachine = statisticRes?.code === 200 && (statisticRes.data?.machines ?? 0) > 0;
        const hasEnv = statusRes?.code === 200 && (statusRes.data?.supply?.length ?? 0) > 0;
        this.communicationData = { machine: hasMachine, env: hasEnv };
    }

    private applyStatistic(response: any) {
        const { code, data } = response || {};
        if (code !== 200) return;

        if (data.farm_id) {
            this.farmId = data.farm_id;
        }

        this.machineCount = data.machines ?? 0;
        this.gradeLog = data.log ?? [];

        let quantity = 0;
        let weight = 0;
        let plate = 0;
        for (const item of this.gradeLog) {
            quantity += Number(item?.quantity ?? 0);
            weight += Number(item?.weight ?? 0);
            plate += Number(item?.plate ?? 0);
        }

        this.totalQuantity = quantity;
        this.totalWeight = weight;
        this.totalPlate = plate;

        this.productChart = [...this.gradeLog];
    }

    private applyEggPrice(chartres: any) {
        if (!chartres || chartres.code !== 200) return;

        const datasets = [
            {
                label: '왕란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#F37B48',
                borderColor: '#F37B48',
                tension: 0.01
            },
            {
                label: '특란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#D05A2A',
                borderColor: '#D05A2A',
                tension: 0.01
            },
            {
                label: '대란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#F4956A',
                borderColor: '#F4956A',
                tension: 0.01
            },
            {
                label: '중란',
                data: [],
                fill: false,
                pointRadius: 0,
                backgroundColor: '#FF9F7F',
                borderColor: '#FF9F7F',
                tension: 0.01
            }
        ];

        const labels: string[] = [];

        chartres.data.forEach((item: any) => {
            labels.push(item.date.substring(0, 10));
            datasets[0].data.push(item.egg1 ?? null);
            datasets[1].data.push(item.egg2 ?? null);
            datasets[2].data.push(item.egg3 ?? null);
            datasets[3].data.push(item.egg4 ?? null);
        });

        this.eggprice = {
            title: '계란시세 그래프 (원/30개)',
            link: '/user/monitoring/eggprice',
            linkText: '더보기',
            labels,
            datasets,
            options: {
                plugins: {
                    legend: {
                        position: 'right'
                    }
                }
            }
        };
    }

    private applyCharts(response: any) {
        if (!response || response.code !== 200 || !response.data) return;

        const res = response.data;
        const farmId = this.farmId;

        // 한 번의 순회로 일별 보고서 구성
        const dailyReport: Record<string, any> = {};

        for (const item of (res.supply || [])) {
            const day = (item.date || '').substring(0, 10);
            if (!day) continue;
            if (!dailyReport[day]) dailyReport[day] = {};
            dailyReport[day].water = item.water || 0;
            dailyReport[day].feed = item.feed || 0;
            dailyReport[day].feed_price = item.feed_price || 0;
        }

        for (const item of (res.eggproduct || [])) {
            const day = (item.date || '').substring(0, 10);
            if (!day) continue;
            if (!dailyReport[day]) dailyReport[day] = {};
            dailyReport[day].eggproduct = item.weight || 0;
        }

        for (const item of (res.eggprice || [])) {
            const day = (item.date || '').substring(0, 10);
            if (!day) continue;
            const avgPrice = ((item.egg1 || 0) + (item.egg2 || 0) + (item.egg3 || 0) + (item.egg4 || 0)) / 4;
            if (!dailyReport[day]) dailyReport[day] = {};
            dailyReport[day].eggprice = avgPrice;
        }

        // 한 번의 날짜 순회로 두 차트 데이터 동시 생성
        const labels: string[] = [];
        const nValues: number[] = [];
        const sValues: number[] = [];
        const pValues: number[] = [];
        const fValues: number[] = [];

        const now = new Date();
        const target = new Date();
        target.setMonth(target.getMonth() - 1);

        while (target.getTime() < now.getTime()) {
            const day = target.toISOString().substring(0, 10);
            const item = dailyReport[day] || {};

            const feed = item.feed || 0;
            let feedPrice = item.feed_price || 0;
            const eggPrice = item.eggprice || 0;
            const water = item.water || 0;
            const eggproduct = item.eggproduct || 0;

            if (feedPrice === 0) feedPrice = 600;

            labels.push(day);

            // 난사비·수사비
            nValues.push(eggPrice / feedPrice);
            sValues.push(feed > 0 ? water / feed : 0);

            // 생산효율·사료요구율
            pValues.push(feed > 0 ? eggproduct / feed : 0);
            fValues.push(eggproduct > 0 ? feed / eggproduct : 0);

            target.setDate(target.getDate() + 1);
        }

        this.statisticChart = {
            title: '난사비·수사비',
            description: '* 난사비·수사비를 확인하려면 농장관리-계사정보에 일별 급이량/급수량을 등록해주세요.',
            link: farmId ? `/user/farm/dashboard/${farmId}` : '',
            linkText: '농장관리',
            labels,
            datasets: [
                {
                    label: '난사비',
                    data: nValues,
                    fill: false,
                    pointRadius: 3,
                    backgroundColor: '#F37B48',
                    borderColor: '#F37B48',
                    tension: 0.01
                },
                {
                    label: '수사비',
                    data: sValues,
                    fill: false,
                    pointRadius: 3,
                    backgroundColor: '#F4956A',
                    borderColor: '#F4956A',
                    tension: 0.01
                }
            ],
            options: {
                plugins: {
                    legend: {
                        position: 'top'
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            stepSize: 0.1
                        }
                    }
                }
            }
        };

        this.efficiencyChart = {
            title: '생산효율·사료요구율',
            description: '* 생산효율·사료요구율을 확인하려면 농장관리-계사정보에 일별 급이량을 등록해주세요.',
            link: farmId ? `/user/farm/dashboard/${farmId}` : '',
            linkText: '농장관리',
            labels,
            datasets: [
                {
                    label: '생산효율',
                    data: pValues,
                    fill: false,
                    pointRadius: 3,
                    backgroundColor: '#E06835',
                    borderColor: '#E06835',
                    tension: 0.01,
                    yAxisID: 'y1',
                    order: 1
                },
                {
                    label: '사료요구율',
                    data: fValues,
                    fill: false,
                    pointRadius: 3,
                    backgroundColor: '#FF9F7F',
                    borderColor: '#FF9F7F',
                    tension: 0.01,
                    yAxisID: 'y2',
                    order: 0
                }
            ],
            options: {
                plugins: {
                    legend: {
                        position: 'top'
                    }
                },
                scales: {
                    y1: {
                        type: 'linear',
                        position: 'left',
                        beginAtZero: true,
                    },
                    y2: {
                        type: 'linear',
                        position: 'right',
                        beginAtZero: true,
                        grid: {
                            drawOnChartArea: false
                        }
                    }
                }
            }
        };
    }
}

export default ComponentUserHomeComponent;